import React from 'react';
import List from 'gatsby-matrix-theme/src/gatsby-core-theme/components/organisms/toplist/list';
import { MdKeyboardArrowDown } from '@react-icons/all-files/md/MdKeyboardArrowDown';

export default function index(props) {
  return <List {...props} modulestyle='template_two' loadMoreIcon={<MdKeyboardArrowDown />} />;
}
